/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateCreateFromDashboardRequest
 */
export interface TemplateCreateFromDashboardRequest {
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromDashboardRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromDashboardRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromDashboardRequest
     */
    dashboardKey: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TemplateCreateFromDashboardRequest
     */
    requiredLicenseFeatures?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TemplateCreateFromDashboardRequest
     */
    global?: boolean;
}

/**
 * Check if a given object implements the TemplateCreateFromDashboardRequest interface.
 */
export function instanceOfTemplateCreateFromDashboardRequest(value: object): value is TemplateCreateFromDashboardRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dashboardKey' in value) || value['dashboardKey'] === undefined) return false;
    return true;
}

export function TemplateCreateFromDashboardRequestFromJSON(json: any): TemplateCreateFromDashboardRequest {
    return TemplateCreateFromDashboardRequestFromJSONTyped(json, false);
}

export function TemplateCreateFromDashboardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateCreateFromDashboardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'dashboardKey': json['dashboardKey'],
        'requiredLicenseFeatures': json['requiredLicenseFeatures'] == null ? undefined : json['requiredLicenseFeatures'],
        'global': json['global'] == null ? undefined : json['global'],
    };
}

export function TemplateCreateFromDashboardRequestToJSON(json: any): TemplateCreateFromDashboardRequest {
    return TemplateCreateFromDashboardRequestToJSONTyped(json, false);
}

export function TemplateCreateFromDashboardRequestToJSONTyped(value?: TemplateCreateFromDashboardRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'dashboardKey': value['dashboardKey'],
        'requiredLicenseFeatures': value['requiredLicenseFeatures'],
        'global': value['global'],
    };
}

